<template>
  <v-card>
    <v-card-title :style="{ color: DataPuntoSelecionado.color }">Plan Nacional de Desarrollo</v-card-title>
    <v-card-text>
      Asociación Plan Nacional de Desarrollo y Plan Marco de Implementación
      <v-card>
        <v-card-text>
          <v-row v-if="DataPuntoSelecionado != null">
            <v-col class="d-flex">
              <img
                v-if="DataPacto != null"
                
                id="pns"
                alt="PNS"
                height="90"
                v-bind:src=DataPacto.imagen
                class="gray float-left mr-3"
              />
              <v-layout row wrap class="mx-4">
                <v-flex xs12 sm12>
                  <v-layout>
                    <v-menu
                      :open-on-hover="false"
                      :close-on-content-click="true"
                      :offset-x="false"
                      :offset-y="true"
                    >
                      <template v-slot:activator="{ on }" v-if="DataPuntoSelecionado != null">
                        <div
                          class="v-labelstrong"
                          :style="{ color: DataPuntoSelecionado.color }"
                        >
                          {{ DataPuntoSelecionado.nombre }}
                          <v-btn text icon v-on="on">
                            <v-icon>icon-list</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <v-list v-if="gpuntos != null">
                        <v-list-item
                          v-for="(item, index) in gpuntos"
                          :key="index"
                          @click="SelectPunto(item)"
                          v-model="urlidpunto"
                        >
                          <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-layout>
                    <v-menu
                      :open-on-hover="false"
                      :close-on-content-click="true"
                      :offset-x="false"
                      :offset-y="true"
                    >
                      <template v-slot:activator="{ on }" v-if="DataPacto != null">
                        <div
                          class="v-labelstrong"
                          :style="{ color: DataPuntoSelecionado.color }"
                        >
                          {{ DataPacto.nombre }}
                          <v-btn text icon v-on="on">
                            <v-icon>icon-list</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in gnivelpndbypunto"
                          v-model="urlidnivelpnd"
                          :key="index"
                          @click="SelectPacto(item)"
                        >
                          <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12>{{ DataPacto.descripcion }}</v-flex>
              </v-layout>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-title
          :style="{ color: DataPuntoSelecionado.color }"
        >Indicadores del Plan Nacional de Desarrollo que vinculan contenidos del PMI</v-card-title>
        <v-card-text>
          <v-select
            v-model="Lineaseleccionada"
            :items="DataPactosHijosSeleccionados"
            item-text="nombre"
            item-value="idnivelpnd"
            :label="labelselect"
          ></v-select>

          <v-data-table
            :headers="HeaderIndicadorPND"
            :items="DataIndicadoresPND"
            class="elevation-1"
            :no-data-text="gnodata"
            :items-per-page="5"
          >
            <template v-slot:item.action="{ item }">
              <a :href="item.ruta" style="text-decoration: none;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon small class="mr-2" v-on="on" @click="verIndicadorPND(item)" >mdi-eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
              </a>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-title
          :style="{ color: DataPuntoSelecionado.color }"
        >Indicador(es) del Plan Marco de Implementación asociado(s) al Plan Nacional de Desarrollo</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="HeaderIndicadorPMI"
            :items="DataIndicadoresPMI"
            class="elevation-1"
            :no-data-text="gnodata"
            :items-per-page="5"
          >
            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small class="mr-2" v-on="on" @click="verIndicadorPMI(item)">mdi-eye</v-icon>
                </template>
                <span>Ver</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>
<script>
import periodo from "../../stores/_periodo.js";
import store from "../../stores/index.js"
import { mapActions, mapGetters } from "vuex";
export default {
  name: "comparativodetalle",
  data() {
    return {
      DataPuntoSelecionado: [],
      DataPacto: [],
      DataPactosSeleccionados: [],
      DataPactosHijosSeleccionados: [],
      urlidpunto: 0,
      urlPeriodo:".",
      urlidnivelpnd: 0,
      urlidplannacional: 0,
      labelselect: "",
      Lineaseleccionada: 0,
      HeaderIndicadorPND: [
        { text: "Nombre", value: "nombre", align: "left" },
        { text: "ruta", value: "ruta", align: " d-none" },
        {
          text: "Detalle",
          value: "action",
          align: "center",
          sortable: false,
          width: "30px",
        },
      ],
      HeaderIndicadorPMI: [
        { text: "Codigo", value: "codigo", align: "left" },
        { text: "Nombre", value: "nombre", align: "left" },
        { text: "idindicador", value: "idindicador", align: " d-none" },
        {
          text: "Detalle",
          value: "action",
          align: "center",
          sortable: false,
          width: "30px",
        },
      ],
      DataIndicadoresPND: [],
      DataIndicadoresPMI: []
    };
  },
  methods: {
    ...mapActions([
      "puntoPND",
      "get_plannacionaldesarrollo",
      "get_nivelespndbypunto",
      "get_nivelpndbynivel",

      "get_nivelespnd",
      "get_nivelrecursopnd",
      
      
    ]),
    filtrarpunto() {
      this.DataPuntoSelecionado = this.gpuntos.filter(
        (p) => p.idpunto == this.urlidpunto
      )[0];
      this.get_nivelespndbypunto({
        params: {
          idpunto: this.urlidpunto,
          periodo: this.urlPeriodo
        }
      })
    },
    filtrarnivelpnd() {
      this.DataPacto = this.gnivelpndbypunto.filter((element) => {
        if (element.idnivelpnd == this.urlidnivelpnd) {
          return element;
        }
      })[0];
      
      this.get_nivelpndbynivel({
        params: {
          idpunto: this.urlidpunto,
          idnivelpnd: this.DataPacto.idnivelpnd
        }
      });

    },
    filtrarhijospnd() {
      this.DataPactosHijosSeleccionados = this.gnivelpndbynivel[0].hijosPnd
      if (this.DataPactosHijosSeleccionados.length > 0 && this.Lineaseleccionada == 0)
      {
        this.Lineaseleccionada = this.DataPactosHijosSeleccionados[0].idnivelpnd;
      }
    },
    filtrarnivelporpacto() {
      this.DataPactosSeleccionados = this.gnivelpndbypunto;
      if (this.urlidnivelpnd == 0) {
        this.urlidnivelpnd = this.DataPactosSeleccionados[0].idnivelpnd;
        this.filtrarnivelpnd();
        this.SelectPacto(this.DataPactosSeleccionados[0]);
      }
    },
    SelectPunto(item) {
      this.urlidpunto = item.idpunto;
      this.urlidnivelpnd = 0;
      this.DataIndicadoresPND = [];
      this.DataIndicadoresPMI = [];
      this.filtrarpunto();
    },
    SelectPacto(item) {
      this.DataPacto = item;
      this.urlidnivelpnd = item.idnivelpnd;
      this.DataIndicadoresPND = [];
      this.DataIndicadoresPMI = [];
      this.filtrarhijospnd();
      this.Lineaseleccionada = 0;
      this.get_nivelpndbynivel({
        params: {
          idpunto: this.urlidpunto,
          idnivelpnd: this.DataPacto.idnivelpnd
        }
      });
    },
    verIndicadorPMI(item) {
      //guardamos las variables en un store para devolver al usuario al mismo punto
      let values = [];
      values[1] = this.urlidpunto;
      values[2] = this.urlidnivelpnd;
      values[3] = this.Lineaseleccionada;
      values[4] = this.urlidplannacional;
      values[5] = this.urlPeriodo;
      this.$store.dispatch("saveVrblesPND", values);


      let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
      let env = global[global.env];
      this.$aes.setKey(env.path.secret);
      let cifra = this.$aes.encrypt(item.idindicador.toString());
      let temporal = Math.random().toString(36).substring(2, 6) +
        cifra + Math.random().toString(36).substring(2, 6);
      let encrypted = this.$aes.encrypt(temporal);
      encrypted = encrypted.replace(/\//g, "AbcYq");
      encrypted = encrypted.replace(/\+/g, "qYcbA");
      this.$router.push("/detalleindicadorpublico/" + encrypted);
    },
    verIndicadorPND(item) {
      let ruta = "https://sinergia20app.dnp.gov.co/ciudadano/detalle-indicador/"+item.idindicadorpnd+"";
      window.open(ruta,'_blank');
    },
  },
  created() {
    let varSession =  this.$store.getters.getVariablesPND;
    if (varSession.length > 0)
    {
      this.urlidpunto = varSession[1];
      this.urlidnivelpnd = varSession[2];
      this.Lineaseleccionada = varSession[3];
      this.urlidplannacional = varSession[4];
      this.urlPeriodo = varSession[5];
    } else
    {
      this.urlidpunto = this.$route.params.idpunto;
      this.urlidnivelpnd = this.$route.params.idnivelpnd;
      this.urlidplannacional = this.$route.params.idplannacionaldesarrollo;
      this.urlPeriodo = this.$route.params.periodo;
    }
    
    
    this.get_nivelrecursopnd({
      params: {
        idplannacionaldesarrollo: this.urlidplannacional,
      },
    });

    if (this.gpuntos == null) {
      this.puntoPND({
        params: {
          idplannacionaldesarrollo: this.urlidplannacional,
        },
      });
    } else {
      this.filtrarpunto();
    }
  },
  
  computed: {
    ...mapGetters([
      "gpuntos",
      "gplanesnacionaldesarrollo",
      "gnivelpndbypunto",
      "gnivelpndbynivel",
      "gnivelrecursopnd",
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
  },
  watch: {
    gpuntos: function () {
      this.filtrarpunto();
    },
    gnivelpndbypunto: function () {
      this.filtrarnivelporpacto();
    },
    gnivelpndbynivel: function(){
      this.filtrarhijospnd();
    },
    gnivelrecursopnd: function () {
      if (this.gnivelrecursopnd.length > 0)
        this.labelselect = this.gnivelrecursopnd[1].valor;
    },
    DataPactosSeleccionados: function () {
      this.filtrarnivelpnd();
    },
    Lineaseleccionada: function () {
      this.DataIndicadoresPND = this.gnivelpndbynivel[0].indicadorPnd.filter(
        (p) => p.idnivelpnd == this.Lineaseleccionada
      )
      this.DataIndicadoresPMI = this.gnivelpndbynivel[0].indicador.filter(
       (p) => p.nivelPNDrelacionado == this.Lineaseleccionada 
      )
    },
  },
};
</script>